<script>
    import app from "./stores/app";
    import user from "./stores/user";
    import {SENT_VIA} from './lib/constants';
    import {Link} from './router';
    import {createEventDispatcher} from 'svelte';
    import {convertDate} from './lib/lib';
    import MessageReports from './MessageReports.svelte';

    export let message;
    let showReports = false; // MessageReports
    let date;

    const dispatch = createEventDispatcher();

    const resend_message = () => {
        dispatch('resend', {
            id: message.id,
        });
    }

    const openReports = () => {
        app.selectSmsSent(message.id);
        showReports = true;
    }

    $: {
        date = convertDate(message.date_sent)
    }
</script>

<tr class="pointer" class:selected={ $app.selectedSentId == message.id } on:click="{ openReports }">
    <td class="row-header">
        { date }
    </td>
    {#if $user.is_admin}
        <td class="data">
            <span class="caption">Λογαριασμός:</span><span class="value">{ message.username }</span>
        </td>
    {/if}
    <td class="originator">{ message.originator }</td>
    <td class="message">{ message.sms }</td>
    <td class="data text-right">
        <span class="caption">Παραλήπτες:</span><span class="value">{ message.total_recipients }</span>
    </td>
    <td class="data text-right last">
        <span class="caption">Αρ. Αναφορών:</span><span class="value">{ message.total_reports }</span>
    </td>
    {#if $user.is_admin}
        <td class="data">
            <span class="caption">Από:</span><span class="value">{ SENT_VIA[message.sent_via] }</span>
        </td>
    {/if}
    <td class="row-actions">
        <Link href="/app/resendmessage/{ message.id }" title="Επανάληψη αποστολής"><i class="fa fa-share"></i></Link>
    </td>
</tr>

<MessageReports sms_id="{ message.id }" showReports="{ showReports }" on:close="{ showReports = false }"/>
